import React from "react";

import { Heading2 } from "widgets";
import DeleteIcon from "@mui/icons-material/Delete";

import styles from "./CreatedPackageFeatureOfferings.module.scss";

const DisplayDetails = ({ title, value }) => (
  <div className={styles.displayDetails}>
    <span className={styles.title}>{title}</span>
    <span className={styles.value}>{value || "N/A"}</span>
  </div>
);

const CreatedPackageFeatureOfferings = (props) => {
  const {
    products,
    services,
    handleDeleteProductFeatureOffering,
    handleDeleteServiceFeatureOffering,
  } = props;
  return (
    <div className={styles.mainContainer}>
      <Heading2 heading="Package Feature Offerings" />
      <div className={styles.offeringInnerContainer}>
        {products?.map((product, index) =>
          product.offering_id ? (
            <div className={styles.productOfferings} key={index}>
              <div className={styles.DeleteIcon}>
                <DeleteIcon
                  className={styles.DeleteIconColor}
                  onClick={() => handleDeleteProductFeatureOffering(index)}
                />
              </div>
              <DisplayDetails
                title="Offering Name"
                value={product.offering_name}
              />
              <DisplayDetails
                title="Description"
                value={product.offering_description}
              />
              <div className={styles.defaultValues}>
                <DisplayDetails title="Quantity" value={product.quantity} />
              </div>
            </div>
          ) : null
        )}
        {services?.map((service, index) =>
          service.offering.id ? (
            <div className={styles.serviceOfferings} key={index}>
              <div className={styles.DeleteIcon}>
                <DeleteIcon
                  className={styles.DeleteIconColor}
                  onClick={() => handleDeleteServiceFeatureOffering(index)}
                />
              </div>
              <DisplayDetails
                title="Offering Name"
                value={service.offering?.name}
              />
              <DisplayDetails title="Features" value={service.feature?.name} />
              <DisplayDetails title="Description" value={service.description} />
              <div className={styles.defaultValues}>
                <DisplayDetails
                  title="Usage Date"
                  value={
                    service.start_and_end_usage_date
                      ? `${
                          service.start_and_end_usage_date.start_usage_date 
                        } to ${
                          service.start_and_end_usage_date.end_usage_date 
                        }`
                      : "N/A"
                  }
                />
                <DisplayDetails title="Quantity" value={service.quantity} />
                <DisplayDetails title="Duration" value={service.duration} />
              </div>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default CreatedPackageFeatureOfferings;
